/* eslint-disable react-hooks/exhaustive-deps */
import { getCompletion } from '@/api/characteristics';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import {
  CharacteristicsData,
  CompletionData,
} from '../../api/characteristics/types';
import { PropertyType, Status } from '../../api/enumerations';
import { WorkOrderData } from '../../api/workOrders/types';
import useErrorMessage from '../../hooks/useErrorMessage';
import useGeneral from '../../hooks/useGeneral';
import { usePropertyData } from '../../hooks/usePropertyData';
import useSnackbar from '../../hooks/useSnackbar';

interface CharacteristicsHook {
  propertyData: WorkOrderData | undefined;
  characteristicsData: CharacteristicsData | undefined;
  propertyType: PropertyType | undefined;
  completionData: CompletionData | undefined;
  getCharacteristicsCompletion: () => Promise<void>;
  loadingPage: boolean;
}

const useCharacteristics = (): CharacteristicsHook => {
  const [completionData, setCompletionData] = useState<
    CompletionData | undefined
  >();
  const [loadingCompletion, setLoadingCompletion] = useState(true);

  const { pathname } = useLocation();
  const getStatus = (): Status => {
    if (pathname.includes('/report')) return Status.REPORT;
    if (pathname.includes('/archived')) return Status.ARCHIVED;
    return Status.REVISION;
  };
  const status = getStatus();

  const { osId } = useGeneral();
  const { propertyData, loadingPage } = usePropertyData({ status });
  const { getErrorMessage } = useErrorMessage();
  const { handleSnackbar } = useSnackbar();
  const getCharacteristicsCompletion = async (): Promise<void> => {
    setLoadingCompletion(true);
    try {
      const response = await getCompletion(osId);

      if (response.detail.description)
        throw new Error(response.detail.description);

      if (!response.data) throw new Error('Algo deu errado, tente novamente.');

      setCompletionData(response.data);
    } catch (error) {
      handleSnackbar(getErrorMessage(error), true);
    } finally {
      setLoadingCompletion(false);
    }
  };

  useEffect(() => {
    if (!propertyData) return;
    getCharacteristicsCompletion();
  }, [propertyData]);

  return {
    propertyData,
    characteristicsData: propertyData?.property_characteristics_form,
    propertyType: propertyData?.real_estate_kind,
    completionData,
    getCharacteristicsCompletion,
    loadingPage: loadingPage || loadingCompletion,
  };
};

export default useCharacteristics;
